import { render, staticRenderFns } from "./deviceMsgHead.vue?vue&type=template&id=e1121988&scoped=true&"
import script from "./deviceMsgHead.vue?vue&type=script&lang=js&"
export * from "./deviceMsgHead.vue?vue&type=script&lang=js&"
import style0 from "./deviceMsgHead.vue?vue&type=style&index=0&id=e1121988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1121988",
  null
  
)

export default component.exports